import React, {useEffect, useState,useRef } from "react";
import {Link, useHistory} from 'react-router-dom';
import {getEnterprisesServices, postAuthoritiesSubmit, getCompanyInfo, getRecruitsVisibleLists} from "../../service";
import MakePhoneCall from "../../components/makePhoneCall";
import usePhones from "../../routers/usePhones";
import TextLoop from "react-text-loop";
import {useLoading} from "../../components/loading/LoadingProvider";
import useUserInfo from "../../routers/useUserInfo";
import {useModal} from "../../components/modal";

function Enterprise() {
    const [companys,setCompanys] = useState([])
    const [content,setContent] = useState<string>('')
    const [cover,setCover] = useState<boolean>(false)
    const phones = usePhones()
    const userData = useUserInfo(false)
    const loading = useLoading()
    const modal = useModal()
    const { push } = useHistory()
    let array:any =[];
    useEffect(() => {
        getEnterprisesServices().then(res => {
                if(res.code === 1){
                    setContent(res.data.textContent)
                }
            })
    },[])
    // useEffect(() => {
    //     getCompanyInfo().then( res => {
    //         if(res.code === 0){
    //             const companys = res.page.list
    //             array =  companys.map((item:any)=>'恭喜 ['+item.projectName+'] 成为BG联盟认证企业会员！')
    //         }
    //         // console.log('array=>>',array)
    //         setCompanys(array)
    //     })
    // },[])

    const clickHandle = () => {
        if(userData){
            //loading.showLoading()
            loading.hideLoading()
            push('/user/companyCertificate')
        }else{
            modal.show({
                content:'此操作需要登录!',
                confirmText:'去登录',
                success:(res) => {
                    if(res.confirm){
                        push('/login')
                    }
                }
            })
        }
    }
    const clickMaterial = () => {
            loading.hideLoading()
            push('/user/companyMaterial')
    }
    const rollInfo = companys && companys.length > 0 ?<TextLoop  children={companys} ></TextLoop>:''

    return <div >

        <div className="content">
            <div dangerouslySetInnerHTML={{ __html:content }} ></div>
        </div>
        <div  style={{
            position: 'fixed',
            bottom: '60px',
            width:'100%',
            color:'#FFF',
            fontWeight:'bold',
            paddingLeft:'5px',
            whiteSpace:'pre',
            background:'#00306e',
            zIndex:35,
            fontSize:'15px',
            opacity:0.7,
            borderRadius:'.1rem'
        }}>
            {rollInfo}
        </div>

        <div className="Certification course-detail">
            <div className="common-fixed">
                <div className="common-btn" onClick={() => setCover(true)}>
                    <p className="iconfont">&#xe62e;</p>
                    <p>合作咨询</p>
                </div>
                <div   onClick={ clickHandle }  className="common-btn">认证查询</div>

                <div style={{borderLeft:'1px solid #eee'}} onClick={ clickMaterial }  className="common-btn">资料下载</div>
            </div>
        </div>

        <MakePhoneCall show={ cover } telephone={ phones[5] } onClose={() => setCover(false)}/>
    </div>
}

export default Enterprise;
